export default "__VITE_ASSET__CsnOgWuX__"